import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import Form from './Form';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import { useQueryMutation } from '@lore/query-connect';
import DESCRIPTION_MAX_LENGTH from '../network_support_question_create/DESCRIPTION_MAX_LENGTH';

Dialog.propTypes = {
  networkSupportQuestion: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { networkSupportQuestion } = props;

  const [data, setData] = useState({
    stewardName: networkSupportQuestion.data.stewardName,
    stewardDescription: networkSupportQuestion.data.stewardDescription,
    stewardEmail: networkSupportQuestion.data.stewardEmail,
    stewardPhone: networkSupportQuestion.data.stewardPhone,
    stewardAvatarUrl: networkSupportQuestion.data.stewardAvatarUrl,
    stewardCustomUrl: networkSupportQuestion.data.stewardCustomUrl,
    stewardCustomLabel: networkSupportQuestion.data.stewardCustomLabel,
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('networkSupportQuestion.update', networkSupportQuestion);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          stewardName: [validators.isRequired],
          stewardDescription: [validators.isRequired, validators.maxLength(DESCRIPTION_MAX_LENGTH)],
          // stewardEmail: [validators.number.isRequired],
          // stewardPhone: [validators.number.isRequired],
          // stewardCustomUrl: [validators.number.isRequired],
          // stewardCustomLabel: [validators.number.isRequired],
          // stewardAvatarUrl: [validators.number.isRequired]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  data={data}
                  onClose={() => {
                    props.onClose();
                    setTimeout(function() {
                      props.onSubmit && props.onSubmit(request)
                    }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Support contact updated.
                  </SuccessMessage>
                ) : null}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
